import { render, staticRenderFns } from "./Login2.vue?vue&type=template&id=49f7ec68&scoped=true"
import script from "./Login2.vue?vue&type=script&lang=js"
export * from "./Login2.vue?vue&type=script&lang=js"
import style0 from "./Login2.vue?vue&type=style&index=0&id=49f7ec68&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f7ec68",
  null
  
)

export default component.exports